// extracted by mini-css-extract-plugin
module.exports = {"ajax-error":"ajax-modal_ajax-error__v4zqi"};